import { render, staticRenderFns } from "./ServerOrders.vue?vue&type=template&id=1bd41636"
import script from "./ServerOrders.vue?vue&type=script&lang=js"
export * from "./ServerOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports